import Page from './../../classes/Page'
import { gsap } from "gsap";

export default class extends Page {
  constructor () {
    super({
      id: 'home',


      element: '#main', //this should be available to all pages
      elements: {
        // wrapper: '.home__wrapper',
        // navigation: document.querySelector('.navigation'),
      }
    })

    this.initialised = false
  }

  create () {
    super.create()

    // if (document.querySelector('.c-hero')) {
    //   import(
    //     '../../components/Hero.js'  /* webpackChunkName: "components/hero" */
    //   ).then((Hero) => {
    //     this.hero = new Hero.default(initialised);
    //   })
    // }

    console.log('Create HOME page')

  }

  /**
   * Animations.
   */
  show () {

    if (this.isPopState) {
      this.duration = 0
    } else {
      this.duration = 0.25
    }

    this.isPopState = false
    this.timelineIn = new gsap.timeline()

    if (document.querySelector('.c-hero')) {
      import(
        '../../components/Hero.js' /* webpackChunkName: "components/hero" */
      ).then((Hero) => {
        this.hero = new Hero.default(this.initialised)
        this.initialised = true

        this.timelineIn.to(this.element, {
          duration: this.duration,
          autoAlpha: 1,
        })
      })
    }


    return super.show(this.timelineIn)
  }

  hide () {

    if (this.isPopState) {
      this.duration = 0
    } else {
      this.duration = 0.5
    }
    
    // this.removeEventListeners()
    console.log('Hide the HOME page')
    this.timelineOut = new gsap.timeline()

    this.timelineOut.to(this.element, {
      duration: this.duration,
      autoAlpha: 0
    })

    this.timelineOut.call(() => {
      this.destroy()
    })

    return super.hide(this.timelineOut)
  }

  /**
   * Events.
   */
  onPopState () {
    this.isPopState = true
  }
  
  /**
   * Loop.
   */
  update () {
    // super.update()
  }

  /**
   * Destroy.
   */
  destroy () {
    super.destroy()
  }
}
